import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  Typography,
} from 'antd';
import { useHistory } from 'react-router';
import abrirCorteIcon from 'views/Dashboard/assets/abrir-corte.png';
import cerrarCorteIcon from 'views/Dashboard/assets/cerrar-corte.png';
import ventanillaIcon from 'views/Dashboard/assets/ventanilla.png';
import registrarTramiteIcon from 'views/Dashboard/assets/registrar-tramite.png';
import reportesTramitesIcon from 'views/Dashboard/assets/reportes-tramites.png';
import seguimientoTramitesIcon from 'views/Dashboard/assets/seguimiento-tramites.png';
import seguimientoTramitesFinalizadosIcon from 'views/Dashboard/assets/seguimiento-tramites-finalizados.png';
// import seguimientoCitasIcon from 'views/Dashboard/assets/seguimiento-tramites.png';
import useCorte from 'hooks/useCorte';
import { getPermission } from 'utils/permission/index';
import { useSelector } from 'react-redux';
import { toMoment } from 'utils/normalizers';
import { permissionConfig as permissionConfigCaja, permissionConfigVentanilla } from 'views/Recaudacion/Caja';
import { permissionConfig as permissionConfigAbrirCorte } from 'views/Recaudacion/Corte/AbrirCorte';
import { permissionConfig as permissionConfigCerrarCorte } from 'views/Recaudacion/Corte/CerrarCorte';
import { permissionConfig as permissionConfigRepTramites } from 'views/Tramites/ReportesDeTramites';
import { permissionConfig as permissionConfigRepContabilidad } from 'views/Tramites/ReportesDeContabilidad';
import { permissionConfig as permissionConfigGPM } from 'views/Tramites/GPM/';
import { permissionConfig as permissionConfigSeguimientoGPM } from 'views/Tramites/SeguimientoDeTramites';
import { permissionConfig as permissionConfigSeguimientoGPMRepuve } from 'views/Tramites/SeguimientoDeTramitesRepuve';
import { permissionConfig as permissionConfigSeguimientoCitas } from 'views/Citas/SeguimientoDeCitas';
import { findItemNested } from 'utils/filters';

const baseStyle = {
  height: 150,
  color: '#FFFFFF',
  backgroundColor: '#2E505F',
  fontSize: 24,
  backgroundPosition: 'left bottom',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 120,
};

const VENTANILLA = process.env.REACT_APP_ENV_ALTERN === 'ventanilla';
const REPUVE = process.env.REACT_APP_ENV_NAME === 'repuve';

const Dashboard = () => {
  const routes = JSON.parse(localStorage.getItem('allRoutes'));
  const history = useHistory();
  const { corte, corteSinCerrar } = useCorte(true);
  const periodoFiscalSelected = useSelector(({ auth }) => auth.periodoFiscalSelected);
  const [mounted, setMounted] = useState(false);

  const permissionCaja = getPermission(permissionConfigCaja);
  const permissionVentanilla = getPermission(permissionConfigVentanilla);
  const permissionAbrirCorte = getPermission(permissionConfigAbrirCorte);
  const permissionCerrarCorte = getPermission(permissionConfigCerrarCorte);
  const reportesTramites = getPermission(permissionConfigRepTramites);
  const reportesContabilidad = getPermission(permissionConfigRepContabilidad);
  const permissionGPM = getPermission(permissionConfigGPM);
  const permissionSeguimientoGPM = getPermission(permissionConfigSeguimientoGPM);
  const permissionSeguimientoGPMRepuve = getPermission(permissionConfigSeguimientoGPMRepuve);
  const permissionSeguimientoCitas = getPermission(permissionConfigSeguimientoCitas);

  const map = (e) => {
    if (!e.visible) return false;
    const match = findItemNested(routes, e.href, 'path');
    if (!match) return false;
    return { ...e, withoutLayout: match.withoutLayout };
  };

  const links = [
    {
      text: 'Abrir corte',
      href: '/recaudacion/corte/abrir-corte',
      style: { backgroundImage: `url(${abrirCorteIcon})` },
      visible: !VENTANILLA && !corte && permissionAbrirCorte.hasAllViewPermission,
    },
    {
      text: `Cerrar corte (${toMoment(corte?.apertura)?.format()})`,
      href: '/recaudacion/corte/cerrar-corte',
      style: { backgroundImage: `url(${cerrarCorteIcon})` },
      icon: cerrarCorteIcon,
      visible: !VENTANILLA && corte && permissionCerrarCorte.hasAllViewPermission,
    },
    {
      text: 'Ventanilla',
      href: '/recaudacion/ventanilla',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${ventanillaIcon})` },
      visible: permissionVentanilla.hasAllViewPermission && periodoFiscalSelected?.vigente,
    },
    {
      text: 'Caja',
      href: '/recaudacion/caja',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${ventanillaIcon})` },
      visible: !VENTANILLA && permissionCaja.hasAllViewPermission && periodoFiscalSelected?.vigente,
      disabled: corteSinCerrar,
    },
    {
      text: 'Reportes de Trámites',
      href: '/tramites/reportes-de-tramites',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${reportesTramitesIcon})` },
      visible: !VENTANILLA && reportesTramites.hasAllViewPermission,
    },
    {
      text: 'Reportes de Recaudación',
      href: '/recaudacion/reportes-de-recaudacion',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${abrirCorteIcon})` },
      visible: !VENTANILLA && reportesContabilidad.hasAllViewPermission,
    },
    {
      text: 'Registrar trámite',
      href: '/tramites/registrar-tramite',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${registrarTramiteIcon})` },
      visible: permissionGPM.hasAllViewPermission,
    },
    {
      text: 'Seguimiento de trámites',
      href: '/tramites/seguimiento-de-tramites',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${seguimientoTramitesIcon})` },
      visible: permissionSeguimientoGPM.hasAllViewPermission,
    },
    {
      text: 'Seguimiento de trámites finalizados',
      href: '/tramites/seguimiento-de-tramites-finalizados',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${seguimientoTramitesFinalizadosIcon})` },
      visible: permissionSeguimientoGPMRepuve.hasAllViewPermission,
    },
    {
      text: 'Seguimiento de citas',
      href: '/citas/seguimiento-de-citas',
      style: { backgroundColor: '#2E5F47', backgroundImage: `url(${seguimientoTramitesIcon})` },
      // style: { backgroundColor: '#2E5F47', backgroundImage: `url(${seguimientoCitasIcon})` },
      visible: REPUVE && permissionSeguimientoCitas.hasAllViewPermission
        && !permissionSeguimientoGPM.hasAllViewPermission,
    },
  ].map(map).filter((e) => e);

  useEffect(() => {
    if (links.length === 1 && !links[0].withoutLayout) {
      history.push(links[0].href);
    } else {
      setMounted(true);
    }
  }, [links]);

  if (!mounted) return null;

  return (
    <Row gutter={[20, 20]} style={{ padding: 30 }}>
      {links.map((e) => (
        <Col xs={24} sm={24} md={12} lg={12} xl={8} key={e.text}>
          <Button
            block
            onClick={() => history.push(e.href)}
            shape="round"
            style={{ ...baseStyle, ...e.style }}
            className="no-color"
            disabled={e.disabled}
          >
            <Typography.Text style={{
              float: 'right',
              width: 'calc(100% - 100px)',
              whiteSpace: 'break-spaces',
              color: baseStyle.color,
              lineHeight: 1,
            }}
            >
              {e.text}
            </Typography.Text>
          </Button>
        </Col>
      ))}
    </Row>
  );
};

export default Dashboard;
